module.exports = __webpack_public_path__ + "img/swallows-logo-icon.ec5d673f.png";